var $ = require('jquery');


const FORM_ERROR_CLASS = 'floating-label__input--invalid';

$(function() {

    let _emailSubscribeForm = $('#footerEmailSubscribeForm');

    if(_emailSubscribeForm) {
        _emailSubscribeForm.keydown(function(){
            let _dupEmailSubscribeError = $('#dupEmailSubscribeError');
            if(_dupEmailSubscribeError) _dupEmailSubscribeError.remove();
        });

        _emailSubscribeForm.submit(function(e){
            e.preventDefault();
            sendSubscribeEmail();
        });
    }

});

function sendSubscribeEmail() {
    let emailSubscribeForm = $('#footerEmailSubscribeForm');
    if (!formHasErrors(emailSubscribeForm)){
        let email = $('#email-subscribe').val();

        let dataObject = {
            email: email
        };
        let data = $.param(dataObject);
        $.ajax({
            type: 'POST',
            url: '/account/ajax/signUpForNewsLetter',
            data: data,
            success: function (rtn) {
                if (rtn.success) {
                    showSuccessEmailSubscribeMsg();
                    if (typeof window.PAGE_TRACK_A_MODULE !== 'undefined' && $.isFunction(window.PAGE_TRACK_A_MODULE.insertEventTrack)) {
                        window.PAGE_TRACK_A_MODULE.insertEventTrack('news_letter_in_footer', 'subscribe', 'email:' + email);
                    }
                } else if(rtn.duplicate){
                    showDuplicateEmailSubscribeMsg();
                } else {
                    console.log('Invalid Email');
                }
            }
        });
    }
}

function formHasErrors(form){
    return form.find('input:visible.' + FORM_ERROR_CLASS).length > 0 ||
        form.find('select:visible option:selected').is(':disabled');
}

function showSuccessEmailSubscribeMsg(){
    let _emailSubscribeComponent = $('#emailSubscribeComponent');
    const successEl = $('<p role="alert" class="u-error">Woohoo! You\'re officially on the Lovers + Friends list!</p>');
    successEl.insertAfter(_emailSubscribeComponent);
    _emailSubscribeComponent.remove();
}

function showDuplicateEmailSubscribeMsg(){
    let _emailSubscribeComponent = $('#emailSubscribeComponent');
    const duplicateEl = $('<p role="alert" id="dupEmailSubscribeError" class="u-error">Oops! Looks like you\'re already signed up!</p>');
    duplicateEl.insertAfter(_emailSubscribeComponent);
}


// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/footer/index.js